// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"97878584","455":"edb3e1b9","977":"1b2631ea"}[chunkId] + ".chunk.js";
};